var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarDays = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 13.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.5 16.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M8.25 17.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M9.75 16.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M10.5 17.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M12 16.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M12.75 17.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M14.25 16.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M15 17.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M16.5 16.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M15 13.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M16.5 14a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.75 2.75a.75.75 0 0 1 .75.75V5h9V3.5a.75.75 0 0 1 1.5 0V5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3H6V3.5a.75.75 0 0 1 .75-.75m13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendarDays;